import './style.scss';

import React, { useEffect, useState } from 'react';
import { Loading } from 'views/components/atoms/loading';
import { BodyShowList, ListBody } from 'views/components/molecules/listBody';
import { ListHeader, ListHeaderType } from 'views/components/molecules/listHeader';

type ListProps = {
  bodyShowLists: BodyShowList[];
  headerShowList: ListHeaderType[];
  onClick?: (index: number, bodyShowList: BodyShowList) => void;
  loading?: boolean;
};

export const List: React.FC<ListProps> = ({ bodyShowLists, headerShowList, onClick, loading }) => {
  const handleClick = (index: number, data: BodyShowList) => {
    // ListBodyがクリックされたときに、onClickプロパティに渡されたクリックハンドラを呼び出す
    if (onClick) {
      onClick(index, data);
    }
  };
  const [showLoading, setShowLoading] = useState<boolean>(false);
  useEffect(() => {
    if (loading) {
      setShowLoading(true);
    } else {
      setShowLoading(false);
    }
  }, [loading]);
  return (
    <>
      <ListHeader headerShowList={headerShowList} />
      {loading
        ? showLoading && (
            <div className="loadingWrapper">
              <Loading />
            </div>
          )
        : bodyShowLists.map((bodyShowList, index) => {
            return (
              <ListBody key={index} bodyShowList={bodyShowList} onClick={() => handleClick(index, bodyShowList)} />
            );
          })}
    </>
  );
};
